import { AthosFetcher } from 'libs/athos/classes/athos-fetcher'
import { normaliseResults } from 'libs/athos/helpers/normalisers'

import { generateAthosProvider } from 'libs/athos/fetchers/provider'
import { isAthosInstockOnly } from 'libs/athos/athos-utils'
import type { AthosFetchOptions } from 'libs/athos/athos.types'

export class AthosSearch extends AthosFetcher {
  generateURL() {
    return super.generateURL('/search')
  }

  updateParams(options: AthosFetchOptions = {}) {
    const { query, originalQuery, page, resultsPerPage, tag, filters, sort } = options
    if (!query || query === 'null') return

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('q', query)
    if (isAthosInstockOnly()) this.params.set('bgfilter.ss_available', 1)

    if (resultsPerPage) this.params.set('resultsPerPage', resultsPerPage)
    if (originalQuery) this.params.set('oq', originalQuery)
    if (page) this.params.set('page', page)
    if (tag) this.params.set('tag', tag)

    if (sort) this.params.setSort(sort); else this.params.clearSort()
    if (filters) this.params.setFilters(filters)

    super.updateParams()
  }
}

export const AthosSearchProvider = generateAthosProvider(AthosSearch, async (results) => {
  const normalisedResults = await normaliseResults(results.results)
  return {
    ...results,
    results: normalisedResults
  }
})
